import React from 'react'
import { object, array } from 'yup'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { useValidatorSeeker, useAppToast } from '@ui-seeker/app'
import { isEmpty, postSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { skuGroupUsersModalFilters, reloadSkuGroupFilters } from '../@signals'


export default function SkuGroupUsersModal() {
    const { showToast } = useAppToast()

    const isOpen = !isEmpty(skuGroupUsersModalFilters.value)
    const { skuGroupID, name, customerID, userIDs = [] } = skuGroupUsersModalFilters.value

    const validatorData = useValidatorSeeker({ userIDs }, object({
        userIDs: array().min(1, 'At least one user is required'),
    }))

    const hasErrors = !isEmpty(validatorData.errors)

    const handleClose = () => {
        skuGroupUsersModalFilters.value = {}
    }

    const handleSave = () => {
        showToast.promise(
            postSubmit(`${BACKEND_APIS.MANAGEMENT}/sku-group/sync-users`, {
                skuGroupID,
                userIDs,
            }).then(() => {
                reloadSkuGroupFilters.value += 1
                handleClose()
            })
        )
    }

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Manage Users — {name}</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                {isOpen && <AutocompleteAjaxSeeker
                    urlAjax={`${BACKEND_APIS.MANAGEMENT}/sku-group/user-options`}
                    filters={{ customerID }}
                    label="Users"
                    placeholder="Search users..."
                    multiple
                    value={userIDs}
                    onChange={e => {
                        skuGroupUsersModalFilters.value = {
                            ...skuGroupUsersModalFilters.value,
                            userIDs: e.target.value,
                        }
                    }}
                    error={validatorData.errors?.userIDs}
                    sx={{ mt: 1 }}
                />}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSave} disabled={hasErrors}>Save</Button>
            </DialogActions>
        </Dialog>
    )
}
